import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import CheckBoxField from "../../../../Form/CheckBoxField/CheckBoxField";
import { indexOf } from 'lodash';
import highlightTerm from "./highlightTerm";
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOptionChild = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    child,
    activeFilters,
    onChange,
    searchTerm,
    idPrefix,
    childOptionClass
  } = _ref;
  const childLabel = searchTerm ? highlightTerm(child.label, searchTerm) : child.label;
  const isChecked = indexOf(activeFilters, child.value) >= 0;
  const childId = "".concat(idPrefix).concat(child.value);
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    className: childOptionClass,
    "aria-label": child.label,
    tabIndex: 0,
    children: /*#__PURE__*/_jsx(CheckBoxField, {
      id: childId,
      label: childLabel,
      value: isChecked,
      onChange: e => onChange(child, e.target.checked)
    })
  });
});
FilterOptionChild.propTypes = {
  child: PropTypes.object.isRequired,
  activeFilters: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  idPrefix: PropTypes.string.isRequired,
  childOptionClass: PropTypes.string
};
export default FilterOptionChild;
//# sourceMappingURL=FilterOptionChild.js.map